import { render } from "./ImportedHorsesPage.vue?vue&type=template&id=da8727be&scoped=true"
import script from "./ImportedHorsesPage.vue?vue&type=script&lang=js"
export * from "./ImportedHorsesPage.vue?vue&type=script&lang=js"

import "./ImportedHorsesPage.vue?vue&type=style&index=0&id=da8727be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da8727be"]])

export default __exports__